<template>
  <div >
    <AutoComplete class="w-full" v-model="keySearchAreaName" optionLabel="name" @change="onAreaNameChange"
      :suggestions="listArea" @complete="fetchAllArea()" placeholder="Chọn Tỉnh/TP - Quận/Huyện">
    </AutoComplete>
  </div>
  
</template>
<script setup>
import { ref, watchEffect } from 'vue';
import API from '../../../api/api-main';
const listArea = ref([])
const listLocation = ref([])
defineProps({
  typeAutoComplete: {
    type: String,
    required: false
  },


})
const emit = defineEmits(["change", "onAreaNameChange", "onLocationNameChange"]);
const keySearchAreaName = ref("")
const keySearchLocationName = ref("")
const data = ref([])
const fetchAllArea = async (name) => {
  try {
    const res = await API.get(`Area/search/${keySearchAreaName.value || name}`);
    listArea.value = res.data;
  } catch (error) {
    console.log(error);
  }
};
watchEffect(() => {
  emit("change", data.value);
});
const onAreaNameChange = (e) => {
  emit('onAreaNameChange', e);
};
const onLocationNameChange = (e) => {
  emit('onLocationNameChange', e)
}

</script>
<style>
.p-autocomplete .p-autocomplete-input {
  width: 100%;
}
</style>